import React from 'react'

// store subtotals, shipping, taxes, grand total
export const TotalsContext = React.createContext([]);


